export default {
  have_account: 'Masz konto?',
  sign_in: 'Zaloguj się',
  sign_in_description: 'aby użyć punktów i zapisanych danych',
  join_free: 'Dołącz bezpłatnie',
  join_description: '— zdobywaj nagrody przy każdym zamówieniu',
  join_description_with_discount: `— zdobywaj nagrody, np. do <highlight>{{max_discount}} zniżki</highlight> przy każdym zamówieniu`,
  join_description_with_product_and_discount: `— zdobywaj nagrody, np. darmowe {{product_name}} i do <highlight>{{max_discount}} zniżki</highlight> przy każdym zamówieniu`,
  demo_mode: 'Tryb demo',
};
